import { useState, useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../pages/login/authConfig';
import { useDispatch } from 'react-redux';
import { setAzureLogin, initLogin } from '../redux/login/loginSlice';

export const useMicrosoftLogin = () => {
    const { instance } = useMsal();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleLogin = useCallback(async () => {
        if (isLoading) return;
    
        setIsLoading(true);
        setError(null);
    
        try {
          // 🧼 Clear ALL localStorage
          localStorage.clear();

          // 🧼 Clear ALL sessionStorage
          sessionStorage.clear();

          // Delete ALL cookies (non-HttpOnly, current domain/path only)
          document?.cookie?.split(";").forEach((cookie) => {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.slice(0, eqPos) : cookie;
            document.cookie = `${name.trim()}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
          });
    
          // 🧹 Reset MSAL cache and account
          await instance.clearCache();
          await instance.setActiveAccount(null);
    
          // Small delay for safety
          // await new Promise((resolve) => setTimeout(resolve, 300));
    
          // 🚪 Trigger login redirect (more reliable than popup)
          await instance.loginRedirect({
            ...loginRequest,
            prompt: "select_account",
          });
          
          // Note: The page will redirect to Microsoft login, so code after this won't execute
          // The redirect response will be handled in App.js or the callback page
          
        } catch (error) {
          setError(error.message);
        } finally {
          setIsLoading(false);
        }
      }, [instance, dispatch, isLoading]);

    return {
        handleLogin,
        isLoading,
        error
    };
};